import { useFocusEffect } from '@react-navigation/native';
import { useSelectedProfile } from 'hooks/useSelectedProfile';
import { HomeTabScreenProps } from 'navigation/tabs/HomeTab';
import React, { useRef } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { RootState } from 'store/index';

import Dynamic, { DynamicRef } from 'components/Dynamic';
import FocusView from 'components/FocusView';
import IsLoading from 'components/isLoading';

type HomeId =
  | 'home-principal'
  | 'home-principal-adolescente'
  | 'home-infantil'
  | 'assista'
  | 'ouca';
const KIDS_HOME: HomeId = 'home-infantil';
const TEENS_HOME: HomeId = 'home-principal-adolescente';
const ADULTS_HOME: HomeId = 'home-principal';

const HomeScreen: React.FC<HomeTabScreenProps<'Home' | 'Videos' | 'Listen' | 'Generic'>> = ({
  route,
}) => {
  const dynamicRef = useRef<DynamicRef>(null);
  const auth = useSelector((state: RootState) => state.auth);
  const { selectedProfile, isRestrictedProfile, isFetching } = useSelectedProfile();

  const id: HomeId =
    (route.params?.id as HomeId) ||
    (selectedProfile?.isKid && KIDS_HOME) ||
    (isRestrictedProfile && TEENS_HOME) ||
    ADULTS_HOME;

  useFocusEffect(React.useCallback(() => {}, [auth.isAuthenticated]));

  if (isFetching) {
    return (
      <View style={styles.loadingContainer}>
        <IsLoading />
      </View>
    );
  }

  return (
    <FocusView trapFocusUp trapFocusRight style={{ flex: 1 }}>
      <Dynamic
        id={id}
        ref={dynamicRef}
        key={`${id}:${selectedProfile?.ageRating}:${auth.isAuthenticated}`}
      />
    </FocusView>
  );
};

const styles = {
  loadingContainer: {
    flex: 1,
    justifyContent: 'center' as const,
  },
};

export default HomeScreen;
